import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type AutomationDashboard } from '../../api/automation';

const NAV = [
  { to: '/automation/designer', label: 'Workflow Designer' },
  { to: '/automation/rules', label: 'Rule Builder' },
  { to: '/automation/executions', label: 'Execution Monitor' },
  { to: '/automation/approvals', label: 'Approval Center' },
  { to: '/automation/agents', label: 'AI Agent Console' },
  { to: '/automation/templates', label: 'Template Library' },
  { to: '/workflows', label: 'Orchestration Dashboard' },
];

export function AutomationHubPage() {
  const [dashboard, setDashboard] = useState<AutomationDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void automationApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Active Workflows', value: dashboard.active_workflows },
        { label: 'Running Executions', value: dashboard.running_executions },
        { label: 'Pending Approvals', value: dashboard.pending_approvals },
        { label: 'Active Rules', value: dashboard.active_rules },
        { label: 'Active Agents', value: dashboard.active_agents },
        { label: 'Templates', value: dashboard.templates_available },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Automation Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise AI automation, workflow engine, business rules and agent orchestration.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
      {dashboard?.recent_activity && dashboard.recent_activity.length > 0 && (
        <div className="mt-8">
          <h2 className="text-lg font-medium">Recent Activity</h2>
          <ul className="mt-3 space-y-2">
            {dashboard.recent_activity.map((a) => (
              <li key={a.id} className="rounded-lg border p-3 text-sm dark:border-slate-700">
                <span className="font-medium">{a.action}</span> — {a.message}
                <span className="ml-2 text-slate-500">{new Date(a.created_at).toLocaleString()}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
